var map = {
	"./de_DE.json": 1130,
	"./en_AU.json": 1131,
	"./en_CA.json": 1132,
	"./en_GB.json": 1133,
	"./es_AR.json": 1134,
	"./es_ES.json": 1135,
	"./es_MX.json": 1136,
	"./fr_CA.json": 1137,
	"./fr_FR.json": 1138,
	"./it_IT.json": 1139,
	"./nl_NL.json": 1140,
	"./pt_BR.json": 1141,
	"./pt_PT.json": 1142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1129;